import { Link, useLocation } from "react-router-dom";

export function Breadcrumb() {
  const { pathname } = useLocation();

  return (<div className="block vtmn-bg-background-secondary">
    <nav aria-label="Breadcrumb 2" className="vtmn-breadcrumb">
      <ol>
        <li>
          <span className="vtmx-home-line" aria-hidden="true"></span>
          <Link to={'/'}>Home</Link>
        </li>
        {pathname.replace('/', '') &&
          <li aria-current="page" className="vtmn-capitalize">{pathname.replace('/', '')}</li>
        }
      </ol>
    </nav>
  </div>)
}